<template>
  <div class="regist-container">
    <div class="regist-banner"></div>
    <van-form class="regist-form" ref="registForm">
      <div class="hr-container">
        {{ $t("login.accountInfo") }}
      </div>
      <div class="regist-item">
        <p class="label required">{{ $t("login.phone") }}</p>
        <div class="item-value">
          <van-field v-model="registForm.tel" type="tel" maxlength="11" :placeholder="$t('login.pleasephone')"/>
        </div>
      </div>
      <div class="regist-item">
        <p class="label required">{{ $t("login.verificationCode") }}</p>
        <div class="item-value verifyYzm">
          <van-field v-model="registForm.telVerifyCode" type="digit" maxlength="6"
                     :placeholder="$t('login.pleaseverificationCode')"/>
          <p class="verify-box" @click="sendverify">{{ verificationText }}</p>
        </div>
      </div>
      <!-- <div class="regist-item nobor">
          <p class="label required">{{$t("login.loginPw")}}</p>
          <div class="item-value">
              <van-field v-model="registForm.pw" type="password"  :placeholder="$t('login.pleaseLoginPw')" />
          </div>
      </div> -->
      <div class="hr-container">
        {{ $t("login.personalInfo") }}
      </div>
      <div class="regist-item" v-if="configField.relationshipField == 1">
        <p class="label required">{{ $t("login.relation") }}</p>
        <div class="item-value IdType">
          <p style="text-align:right;" align="right" @click="relationFun(3)">
            <span>{{ registForm.relationshipName || ($t("login.pleaseSelect")) }}</span>
            <van-icon name="arrow"/>
          </p>
        </div>
      </div>
      <div class="regist-item" v-if="configField.nameField == 1">
        <p class="label required">{{ $t("login.name") }}</p>
        <div class="item-value">
          <van-field v-model="registForm.name" maxlength="8" :placeholder="$t('login.pleaseName')"/>
        </div>
      </div>
      <div class="regist-item" v-if="configField.idTypeField == 1">
        <p class="label required">{{ $t("login.peperType") }}</p>
        <div class="item-value IdType">
          <p style="text-align:right;" align="right" @click="IdTypeShow = true">
            <span>{{ IdColumns.length != 0 ? IdColumns.find(item => item.value == registForm.idType).text : $t("patient.pleaseselect") }}</span>
            <van-icon name="arrow"/>
          </p>
        </div>
      </div>
      <div class="regist-item" v-if="configField.idTypeField == 1?registForm.idType != 142006:false">
        <p class="label required">{{ $t("login.peperNumber") }}</p>
        <div class="item-value">
          <van-field v-model="registForm.idCode" v-Alphabet @change="IdCodeChange"
                     :placeholder="$t('login.pleasepeperNumber')"/>
        </div>
      </div>
      <div class="regist-item"
           v-if="configField.birthdayField == 1?registForm.idType == 142001?isIDCard(registForm.idCode):true:false">
        <p class="label required">{{ $t("login.birthday") }}</p>
        <div class="item-value IdType">
          <p style="text-align:right;" align="right" @click="registForm.idType != 142001?birthdayShow = true:true">
            <span>{{ registForm.birthday || ($t("login.pleaseSelect")) }}</span>
            <van-icon name="arrow"/>
          </p>
        </div>
      </div>
      <div class="regist-item" v-if="configField.ageField == 1">
        <p class="label required">{{ $t("login.age") }}</p>
        <div class="item-value">
          <van-field v-model="registForm.age" type="digit" :maxlength="3" v-Alphabet
                     :placeholder="$t('login.pleaseAge')"/>
        </div>
      </div>

      <div class="regist-item" v-if="configField.genderField == 1">
        <p class="label required">{{ $t("login.gender") }}</p>
        <div class="item-value gender" align="right">
          <!-- registForm.idType != 142001? -->
          <p class="" @click="registForm.idType != 142001?registForm.gender = 1:true">
            <img src="@/assets/user/radio-icon.png" v-if="registForm.gender == 2">
            <img src="@/assets/user/radio-active-icon.png" v-else>
            <span>男</span>
          </p>
          <!-- registForm.idType != 142001? -->
          <p class="" @click="registForm.idType != 142001?registForm.gender = 2:true">
            <img src="@/assets/user/radio-icon.png" v-if="registForm.gender == 1">
            <img src="@/assets/user/radio-active-icon.png" v-else>
            <span>女</span>
          </p>
        </div>
      </div>
      <div class="regist-item nobor" v-if="configField.emergencyField == 1">
        <p class="label required">{{ $t("login.emergencyContact") }}</p>
        <div class="item-value">
          <van-field v-model="registForm.emergencyTel" type="tel" maxlength="11" :placeholder="$t('login.pleasephone')"/>
        </div>
      </div>
      <div class="regist-item nobor" v-if="configField.contactTel1Field == 1">
        <p class="label ">{{ $t("login.contacts1") }}</p>
        <div class="item-value">
          <van-field v-model="registForm.contactTel1" type="tel" maxlength="11" :placeholder="$t('login.pleasephone')"/>
        </div>
      </div>
      <div class="regist-item" v-if="configField.contactTel1Field == 1 && isPhoneNumber(registForm.contactTel1)">
        <p class="label required">{{ $t("login.contacts1") + $t("login.relation") }}</p>
        <div class="item-value IdType">
          <p style="text-align:right;" align="right" @click="relationFun(1)">
            <span>{{ registForm.relationName1 || ($t("login.pleaseSelect")) }}</span>
            <van-icon name="arrow"/>
          </p>
        </div>
      </div>
      <div class="regist-item nobor" v-if="configField.contactTel2Field == 1">
        <p class="label ">{{ $t("login.contacts2") }}</p>
        <div class="item-value">
          <van-field v-model="registForm.contactTel2" type="tel" maxlength="11" :placeholder="$t('login.pleasephone')"/>
        </div>
      </div>
      <div class="regist-item" v-if="configField.contactTel2Field == 1 && isPhoneNumber(registForm.contactTel2)">
        <p class="label required">{{ $t("login.contacts2") + $t("login.relation") }}</p>
        <div class="item-value IdType">
          <p style="text-align:right;" align="right" @click="relationFun(2)">
            <span>{{ registForm.relationName2 || ($t("login.pleaseSelect")) }}</span>
            <van-icon name="arrow"/>
          </p>
        </div>
      </div>
    </van-form>
    <div class="bottom-btn">
      <van-button
        type="primary"
        :color="!btnDisabled ? 'linear-gradient(180deg, #91E3FF 0%, #49A7FF 100%)' : 'linear-gradient(#499FFF,#49A5FF,#49C1FF)'"
        :disabled="!btnDisabled"
        @click="throttleLogin"
      >
      <!-- @click="registerFun" -->
      {{ $t("login.registAndLogin") }}
      </van-button>
      <p class="gologinpage-txt">
        <span>已有账号？</span>
        <a @click="gologin">去登录</a>
      </p>
    </div>
    <my-overlay :show="IdTypeShow" :showField="'IdTypeShow'">
      <van-picker
        :title='$t("patient.pleaseselect")'
        show-toolbar
        slot="overBox"
        :default-index="papersActive"
        :columns="IdColumns"
        @confirm="onConfirm"
        @cancel="IdTypeShow = false"
      />
    </my-overlay>
    <!-- relationShow -->
    <my-overlay :show="relationShow" :showField="'relationShow'">
      <van-picker
        :title='$t("patient.pleaseselect")'
        show-toolbar
        slot="overBox"
        :default-index="activeIndex"
        :columns="columns"
        @confirm="onRelationConfirm"
        @cancel="relationShow = false"
      />
    </my-overlay>
    <!-- 出生日期 -->
    <my-overlay :show="birthdayShow" :showField="'birthdayShow'">
      <van-datetime-picker
        v-model="birthday"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="dayConfirm"
        slot="overBox"
        type="date"
        :title='$t("patient.pleaseselect")'
      />
    </my-overlay>
    <agreement-popup v-if="popupShowNum == 1" :overSubmit="callbackSubmit"></agreement-popup>
    <verification ref="childverification" :tel="registForm.tel" v-if="verciftionShow"
                  :verciftionclose="verciftionclose"/>
  </div>
</template>

<script>
import verification from '@/components/verification.vue';
import md5 from '@/utils/md5';
import {verifyCode, regist} from "@/api/user"
import {IdColumns, columns} from "@/utils/staticData"
import myOverlay from "@/components/myoverlay"
import {v4 as uuidv4} from 'uuid';
import {patientFieldGet} from "@/api/patient"
import {getLocalDateTime} from "@/utils/date"
import {isIDCard, isPhoneNumber} from "@/utils/vaildate"
import agreementPopup from "./agreementPopup"
import {throttle} from "@/utils/common";
import _ from 'lodash';

let that;
export default {
  components: {verification, myOverlay, agreementPopup},
  data() {
    return {
      popupShowNum: 0,
      throttle,
      registForm: {
        tel: "",
        telVerifyCode: "",
        pw: "123456",
        name: "",
        age: "",
        idType: '',
        relationship: "",
        relationshipName: "",
        idCode: "",
        birthday: "",
        gender: 2,
        emergencyTel: "",
        contactTel1: "",
        contactTel2: "",
        contactRelationship1: "",
        contactRelationship2: "",
        relationName1: "",
        relationName2: "",
      },
      relationType: '',
      activeIndex: "",
      verificationText: this.$t("login.sendverificatCode"),
      timer: this.$store.getters.yzmTime,
      verciftionShow: false,
      relationShow: false,
      // 证件类型
      IdTypeShow: false,
      IdColumns: [],
      papersActive: null,
      configField: {
        relationshipField: 0,
        bindHospField: 0,
        birthdayField: 0,
        emergencyField: 0,
        contactTel1Field: 0,
        contactTel2Field: 0,
        genderField: 0,
        idTypeField: 0,
        ageField: 0,
        idTypeField142001: 0,
        idTypeField142002: 0,
        idTypeField142003: 0,
        idTypeField142004: 0,
        idTypeField142005: 0,
        idTypeField142006: 0,
        nameField: 0,
      },
      // 出生日期
      birthdayShow: false,
      birthday: new Date(1970, 0, 1),
      minDate: new Date(1800, 0, 1),
      maxDate: new Date(),
      getLocalDateTime,
      isPhoneNumber,
      columns,
      isIDCard
    }
  },
  computed: {
    btnDisabled() {
      // console.log(isPhoneNumber(this.registForm.tel) , this.registForm.telVerifyCode , this.registForm.pw , this.registForm.name , (this.registForm.idType == 142001?isIDCard(this.registForm.idCode):this.registForm.idCode) , this.registForm.birthday , this.registForm.gender , isPhoneNumber(this.registForm.emergencyTel));
      // return isPhoneNumber(this.registForm.tel) && this.registForm.telVerifyCode && this.registForm.pw && this.registForm.name && (this.registForm.idType == 142001?isIDCard(this.registForm.idCode):this.registForm.idCode) && this.registForm.birthday && this.registForm.gender && (!this.registForm.emergencyTel?true:isPhoneNumber(this.registForm.emergencyTel));
      return isPhoneNumber(this.registForm.tel)
        && this.registForm.telVerifyCode
        && this.registForm.pw
        && (this.configField.relationshipField == 1 ? this.registForm.relationship : true)
        && (this.configField.nameField == 1 ? this.registForm.name : true)
        && (this.configField.idTypeField == 1 ? (this.registForm.idType == 142001 ? isIDCard(this.registForm.idCode) : this.registForm.idCode) : true)
        && (this.configField.birthdayField == 1 && this.configField.ageField == 1 ? (this.configField.birthdayField == 1 ? this.registForm.birthday : true) || (this.configField.ageField == 1 ? this.registForm.age : true):(this.configField.birthdayField == 1 ? this.registForm.birthday : true) && (this.configField.ageField == 1 ? this.registForm.age : true))
        && (this.configField.genderField == 1 ? this.registForm.gender : true)
        && (this.configField.emergencyField == 1 ? (!this.registForm.emergencyTel ? false : isPhoneNumber(this.registForm.emergencyTel)) : true)
        && (this.configField.contactTel1Field == 1 ? !this.registForm.contactTel1 ? true : isPhoneNumber(this.registForm.contactTel1) : true)
        && (this.configField.contactTel2Field == 1 ? !this.registForm.contactTel2 ? true : isPhoneNumber(this.registForm.contactTel2) : true)
        && (this.configField.contactTel1Field == 1 && !!this.registForm.contactTel1 ? this.registForm.contactRelationship1 : true)
        && (this.configField.contactTel2Field == 1 && !!this.registForm.contactTel2 ? this.registForm.contactRelationship2 : true);
    }
  },
  created() {
    document.title = this.$t("login.regist")
    this.getFieldConfig();
    if (this.$route.query.tel) {
      this.registForm.tel = this.$route.query.tel;
    }
    if (this.$route.query.newType && this.$route.query.newType == 1) {
      this.sendverify()
    }
  },
  mounted() {
    that = this;
  },
  methods: {
    registerFun: _.throttle(() => {
      that.popupShowNum++;
      if (that.popupShowNum > 1) {
        that.goRegistAndLogin();
      }
    }, 500),
    callbackSubmit() {
      this.goRegistAndLogin();
    },
    getFieldConfig() {
      const toast = this.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: this.$t("message.loadingTxt")
      });
      patientFieldGet().then(res => {
        toast.clear();
        if (res.data.errorCode == 0 && res.data.data) {
          this.configField = res.data.data.find(itemA => itemA.appChannel == 101002);
          //    IdColumns.splice(0,1)
          if (this.configField.idTypeField == 1) {
            this.IdColumns = [];
            for (let i = 0; i < IdColumns.length; i++) {
              const it = IdColumns[i];
              if (this.configField.idTypeField142001 == 1 && it.value == 142001) {
                this.IdColumns.push(it)
              }
              if (this.configField.idTypeField142002 == 1 && it.value == 142002) {
                this.IdColumns.push(it)
              }
              if (this.configField.idTypeField142003 == 1 && it.value == 142003) {
                this.IdColumns.push(it)
              }
              if (this.configField.idTypeField142004 == 1 && it.value == 142004) {
                this.IdColumns.push(it)
              }
              if (this.configField.idTypeField142005 == 1 && it.value == 142005) {
                this.IdColumns.push(it)
              }
              if (this.configField.idTypeField142006 == 1 && it.value == 142006) {
                this.IdColumns.push(it)
              }
            }
            if (this.IdColumns.length != 0) {
              this.registForm.idType = this.IdColumns[0].value;
            }
          } else {
            this.registForm.idType = 142006;
          }
        }
      })
    },
    relationFun(type) {
      this.relationType = type;
      this.relationShow = true;
      if (type == 1) {
        this.activeIndex = this.columns.findIndex(item => item.value == this.registForm.contactRelationship1);
      } else if (type == 2) {
        this.activeIndex = this.columns.findIndex(item => item.value == this.registForm.contactRelationship2);
      } else {
        this.activeIndex = this.columns.findIndex(item => item.value == this.registForm.relationship);
      }
    },
    onRelationConfirm(e) {
      if (this.relationType == 1) {
        this.registForm.contactRelationship1 = e.value;
        this.registForm.relationName1 = e.text;
      } else if (this.relationType == 2) {
        this.registForm.contactRelationship2 = e.value;
        this.registForm.relationName2 = e.text;
      } else {
        this.registForm.relationship = e.value;
        this.registForm.relationshipName = e.text;
      }
      this.relationShow = false;
    },
    async submit() {
    },
    // 防止多次点击
    throttleLogin:_.throttle(()=>{
      that.goRegistAndLogin();
    },500),
    // 注册登录
    async goRegistAndLogin() {
      const toast = this.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: this.$t("message.loadingTxt")
      });
      let datadd = {...this.registForm};
      if (datadd.idType == 142006) {
        datadd.idCode = md5(uuidv4().split("-").join(""), 16);
      }
      if (datadd.birthday) {
        datadd.birthday = datadd.birthday.replace(/\//g, '-')
      }
      if (!datadd.pw) {
        datadd.pw = md5("123456")
      } else {
        datadd.pw = md5(this.registForm.pw);
      }
      const res = await this.$store.dispatch('user/register', datadd);
      toast.clear()
      if (res.errorCode == 0) {
        if (this.$route.query.redirect) {
          // console.log(this.$route.query.redirect);
          window.location.href = this.$route.query.redirect
        } else {
          this.$router.push('/')
        }
      } else {
        this.popupShowNum = 0;
        this.$toast.fail(res.errorMsg);
      }
    },
    gologin() {
      this.$router.replace({path: '/user/login'})
    },
    // 回传图形验证码
    verciftionclose(data) {
      if (data.type == 1) {
        this.verciftionShow = false;
        return false;
      }
      if (data.type == 2) {
        this.sendverifyFun(data)
      }
      if (data.type == 3) {
        this.sendverifyFun({})
      }

    },
    // 出生日期 回调
    dayConfirm(e) {
      this.registForm.birthday = this.getLocalDateTime(this.birthday);
      this.birthdayShow = false;
    },
    // 证件类型回调
    onConfirm(e, $index) {
      if (e.value == 142006) {
        this.registForm.idCode = md5(uuidv4().split("-").join(""), 16);
      } else {
        this.registForm.idCode = "";
      }
      this.papersActive = $index;
      this.registForm.idType = e.value;
      this.IdTypeShow = false;
    },
    async sendverifyFun(data) {
      const res = await verifyCode({
        tel: this.registForm.tel,
        ...data
      })
      if (res.data.errorCode == 100001) {
        this.$toast(this.$t("login.photofail"))
        setTimeout(() => {
          this.$refs.childverification.getImgYzmData();
        }, 500)
        return false;
      } else {
        if (res.data.errorCode == 0) {
          this.$toast(this.$t("login.yzmtosend"))
          if (this.timer == this.$store.getters.yzmTime) {
            this.verciftionShow = false;
            let time = setInterval(() => {
              this.timer--;
              this.verificationText = this.timer + 's';
              if (this.timer == 1) {
                clearInterval(time)
                this.verificationText = this.$t("login.sendverificatCode");
                this.timer = this.$store.getters.yzmTime;
              }
            }, 1000);
          }
        }
        this.verciftionShow = false;
      }
    },
    // 性别切换
    selectSex(type) {
      this.registForm.gender = type;
    },
    // 证件号change
    IdCodeChange() {
      if (this.registForm.idType == 142001) {
        if (!isIDCard(this.registForm.idCode)) {
          this.$toast(this.$t("patient.IDCard") + this.$t("patient.formatfail"));
          return false;
        }
        if (parseInt(this.registForm.idCode.substring(16, 17)) % 2 == 0) {
          this.selectSex(2)
        } else {
          this.selectSex(1)
        }
        let birthday = this.registForm.idCode.substring(6, 10) + "-" + this.registForm.idCode.substring(10, 12) + "-" + this.registForm.idCode.substring(12, 14);
        console.log(this.registForm, birthday);
        this.registForm.birthday = this.getLocalDateTime(new Date(birthday));
      }
    },
    // 获取图形验证码
    async sendverify() {
      if (this.timer == this.$store.getters.yzmTime) {
        if (!this.registForm.tel) {
          this.$toast(this.$t("login.pleasephone"))
          return;
        }
        this.verciftionShow = true;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.regist-container {
  overflow: auto;
  background: #F5F6FA;
  min-height: 100%;
  height: max-content;

  .regist-banner {
    height: 3rem;
    background: url("~@/assets/user/regist-banner.png") no-repeat;
    background-size: 100% 100%;
  }

  .regist-form {
    background: #fff;

    .hr-container {
      height: 1.36rem;
      line-height: 1.36rem;
      padding: 0 0.6rem;
      background: #F5F6FA;
      font-size: 0.56rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }

    .regist-item {
      margin: 0 0.6rem;
      height: 2rem;
      display: flex;
      align-items: center;
      border-bottom: 00.02rem solid #F5F6FA;

      .label {
        flex: 0 0 auto;
        margin-right: 0.6rem;
        font-size: 0.54rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #303133;

      }

      .required {
        position: relative;
        padding-left: 0.2rem;

        &::after {
          content: '*';
          position: absolute;
          color: red;
          left: -0.2rem;
          top: 50%;
          line-height: 100%;
          margin-top: 0.15rem;
          // height: -webkit-fill-available;
          transform: translate(0, -50%);
        }
      }

      .item-value {
        flex: 1;

        /deep/ .van-field {
          .van-field__control {
            text-align: right;
            font-size: 0.6rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
          }
        }

      }

      .verifyYzm {
        display: flex;
        align-items: center;

        .van-field {
          flex: 1;
        }

        .verify-box {
          border-left: 0.02rem solid #49A7FF;
          padding-left: 0.4rem;
          flex: 0 0 auto;
          font-size: 0.56rem;
          margin-left: 0.2rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #49A7FF;
          line-height: 0.6rem;
          min-width: 2rem;
          text-align: center;
        }
      }

      .IdType {
        width: 100%;
        font-size: 0.6rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #303133;

        p {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }

        .van-icon {
          font-size: 0.7rem;
          padding-top: 0.15rem;
        }
      }

      .gender {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        p {
          font-size: 0.6rem;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-left: 0.8rem;

          span {
            margin-left: 0.2rem;
          }

          img {
            vertical-align: middle;
            width: 0.6rem;
            height: 0.6rem;
          }

        }
      }
    }

    .nobor {
      border: 0;
    }
  }

  .bottom-btn {
    margin-top: 1.2rem;
    width: 100%;

    .van-button {
      width: 10.72rem;
      height: 1.76rem;
      background: linear-gradient(180deg, #91E3FF 0%, #49A7FF 100%);
      border-radius: 1rem;
      // opacity: 0.4;
      font-size: .64rem;
      margin: 0 auto;
      display: block;
      border: 0;
    }

    .gologinpage-txt {
      font-size: 0.56rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 0.8rem;
      margin: 1.2rem auto;
      text-align: center;

      a {
        color: #49A7FF;
      }
    }
  }
}
</style>
